import React, {useEffect, useRef} from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import {useExitIntent} from "use-exit-intent";

interface Props {
    autoOpenKey?: string
    breakpoints: any
    children: any
    isPreview?: boolean
    linkText?: string
    withAutoOpen?: boolean
    noMaxHeight?: boolean
}

const BREAKPOINTS_KEY: string = 'autoShowOverlayInBreakpoints';

function CCOOverlay({
                        autoOpenKey = 'popupShown',
                        breakpoints,
                        children,
                        isPreview,
                        linkText,
                        withAutoOpen,
                        noMaxHeight
                    }: Props) {
    const [open, setOpen] = React.useState(false);
    const {registerHandler, updateSettings} = useExitIntent();

    const registerHandlerRef = useRef(registerHandler);
    const updateSettingsRef = useRef(updateSettings);
    const withAutoOpenRef = useRef(withAutoOpen);
    const setOpenRef = useRef(setOpen);
    const autoOpenKeyRef = useRef(autoOpenKey);


    useEffect(() => {
        const handleOpen = () => {
            if (!window.sessionStorage.getItem(autoOpenKeyRef.current)) {
                setOpenRef.current(true);
            }
        }
        const handleAutoOpenModal = () => {
            registerHandlerRef.current({
                                           id: 'openDialog',
                                           handler: () => handleOpen(),
                                       })

            updateSettingsRef.current({
                                          mobile: {
                                              triggerOnIdle: true,
                                              delayInSecondsToTrigger: 30
                                          }
                                      })
        }
        if (withAutoOpenRef.current) {
            handleAutoOpenModal()
        }
    }, [registerHandlerRef, updateSettingsRef, withAutoOpenRef, setOpenRef, autoOpenKeyRef])


    const handleClose = () => {
        sessionStorage.setItem(autoOpenKey, 'true');
        setOpen(false)
    }

    return <>
        {!!linkText &&
         <Button variant='outlined'
                 size={'small'}
                 onClick={() => setOpen(true)}>
             {linkText}
         </Button>
        }
        <Dialog data-cypress={'ccoOverlayDialog'} open={isPreview ? true : open}
                onClose={handleClose}
                scroll='body'
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                fullWidth={false}
                maxWidth={false}
                sx={{
                    display: {
                        xs: `${linkText || !breakpoints[BREAKPOINTS_KEY] ||
                               breakpoints[BREAKPOINTS_KEY].includes('xs') ? 'block' : 'none'}`,
                        sm: `${linkText || !breakpoints[BREAKPOINTS_KEY] ||
                               breakpoints[BREAKPOINTS_KEY].includes('sm') ? 'block' : 'none'}`,
                        md: `${linkText || !breakpoints[BREAKPOINTS_KEY] ||
                               breakpoints[BREAKPOINTS_KEY].includes('md') ? 'block' : 'none'}`,
                        lg: `${linkText || !breakpoints[BREAKPOINTS_KEY] ||
                               breakpoints[BREAKPOINTS_KEY].includes('lg') ? 'block' : 'none'}`,
                        xl: `${linkText || !breakpoints[BREAKPOINTS_KEY] ||
                               breakpoints[BREAKPOINTS_KEY].includes('xl') ? 'block' : 'none'}`,
                    },
                    '.MuiPaper-root': {
                        minWidth: '320px',
                        margin: 0,
                    }
                }}>

            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                width: {
                    xs: '320px',
                    sm: '500px',
                    md: '800px',
                    lg: '900px',
                },
                maxHeight: noMaxHeight ? undefined : {
                    xs: '548px',
                    sm: '548px',
                    md: '548px',
                    lg: '548px',
                    xl: '748px',
                },
            }}>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                }}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            padding: '12px',
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Button/>

                </Box>
                <Box sx={{overflowX: 'hidden'}}>
                    {children}
                </Box>
            </Box>
        </Dialog>
    </>;
}

export default CCOOverlay